module.exports = __webpack_public_path__ + "img/cxTrends-13.3af6955c.png";